import { arrayOf, bool, shape, string } from 'prop-types'

import Form from 'views/components/atoms/Form'
import ProductPrice from 'views/components/organisms/ProductPrice'
import ProductStatus from 'views/components/organisms/ProductStatus'
import { PriceListType, StockStatusType } from 'views/utils/propTypes'

const renderProductStatus = stockStatus => (
  <div className="o-ProductPriceInfo__priceInfo" data-qa-id="stock-info">
    <ProductStatus stockStatus={stockStatus} />
  </div>
)

const renderUnitPricing = unitPricing =>
  unitPricing ? (
    <div className="u-margin--bottom o-ProductPriceInfo__unit-pricing">
      ({unitPricing})
    </div>
  ) : null

const ProductPriceInfo = ({
  productId,
  stockStatus,
  unitPricing,
  prices,
  prescriptionMedicine,
  multipleOffer,
  isRxCh,
}) => {
  const renderedStatus = renderProductStatus(stockStatus)
  const renderedUnitPricing = renderUnitPricing(unitPricing)
  return (
    <Form className="o-ProductPriceInfo" name={`buy-${productId}`}>
      <div className="u-hidden@medium u-margin--bottom@small-tiny o-ProductPriceInfo__status-wrapper">
        {!isRxCh && renderedStatus}
      </div>
      <div className="u-margin-small--bottom">
        <ProductPrice
          prescriptionMedicine={prescriptionMedicine}
          multipleOffer={multipleOffer}
          prices={prices}
          stackedDesktop
          displayInfo
        />
      </div>
      <div className="u-hidden@small-tiny">{renderedUnitPricing}</div>
      <div className="u-hidden@small-tiny">{!isRxCh && renderedStatus}</div>
      <div className="u-hidden@medium">{renderedUnitPricing}</div>
    </Form>
  )
}

ProductPriceInfo.propTypes = {
  productId: string.isRequired,
  stockStatus: shape(StockStatusType).isRequired,
  unitPricing: string.isRequired,
  prices: arrayOf(shape(PriceListType)).isRequired,
  prescriptionMedicine: bool,
  multipleOffer: bool,
  isRxCh: bool,
}

ProductPriceInfo.defaultProps = {
  prescriptionMedicine: false,
  multipleOffer: false,
  isRxCh: false,
}

export default ProductPriceInfo
